<script>
import { mapActions } from 'vuex';
export default {
    data: () => ({
        errors : {
            "email": {
                "active": false,
                "message": ""
            },
            "password": {
                "active": false,
                "message": ""
            },
        },
        email: "",
        password : "",
        email_verified: false,
        loading: false,
        error: '',
        advertising: null
    }),
    mounted() {
        this.getCampaign();
    },
    methods: {
        handleSubmit() {
            if(this.email === "") {
                this.errors.email.active = true;
                this.errors.email.message = "El correo es un campo necesario";
                return;
            }
             if(this.password === "") {
                this.errors.password.active = true;
                this.errors.password.message = "La contraseña es un campo necesario";
                return;
            }

            this.errors.email.active = false;
            this.errors.password.active = false;

            this.attemptLogin();
        },
        async attemptLogin() {
            this.loading = true;
            this.error = '';

            try {
                let {data} = await axios.post('/login',{
                    email : this.email,
                    password : this.password
                });
                this.getAuth();
                this.$emit('close');
            } catch (error) {
                console.error(error);
                this.error = (typeof error.response.data.message != 'undefined')
                    ? error.response.data.message
                    : 'Ha ocurrido un error inesperado. Por favor intente nuevamente.';
            } finally {
                this.loading = false;
            }
        },
        async getCampaign() {
            try {
                let {data} = await axios.get('/login-campaign');
                this.advertising = data;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        ...mapActions(['getAuth']),
    }
}
</script>

<template>
<div class="lightbox wrapper__form__auth bg-white flex flex-column sm:flex-row justify-content-between rounded-6 mb-4 sm:mb-10">
    <div class="flex-a px-4 py-6 md:px-12 md:pt-8 md:pb-15 w-100 mb-5 sm:mb-0">
        <img class="auth_logo mb-8" src="/assets/images/layout/AD_Logo/PNG/AutoDeal_Logo_Digital.png" alt="AutoDeal">
        <p class="tx-26 mb-7">
            Bienvenido.
        </p>
        <form @submit.prevent="handleSubmit()">
            <div class="form-group mb-5">
                <label class="form-label form-label--auth">
                    USUARIO
                </label>
                <div class="relative">
                    <input class="form-input form-input--auth" type="text" v-model="email" :class="{ error: this.errors.email.active }">
                    <span class="label_error">incorrecto</span>
                </div>
            </div>
            <div class="form-group mb-5">
                <label class="form-label form-label--auth">
                    PASSWORD
                </label>
                <div class="form-inner">
                    <div class="form-helper form-helper--auth">
                        <img class="auth_icon_eye" src="/assets/images/helpers/eye-regular.svg" alt="">
                    </div>
                    <input class="form-input form-input--auth" type="password" v-model="password" :class="{ error: this.errors.password.active }">
                    <span class="label_error">incorrecto</span>
                </div>
            </div>
            <div class="tx-12 underline flex justify-content-between mb-7">
                <a @click="$emit('recover')">
                    Olvidé mi contraseña
                </a>
                <a @click="$emit('register')">
                    Crear una cuenta
                </a>
            </div>

            <div v-if="error" class="alert alert--warning p-2 fs-12 mb-4">
                {{ error }}
            </div>

            <input class="btn btn--green-ad btn--submit-auth tx-14 weight-500 w-full" type="submit" value="Iniciando sesión, espere..." disabled v-if="loading">
            <input class="btn btn--green-ad btn--submit-auth tx-14 weight-500 w-full" type="submit" value="Entrar" v-else>

        </form>
    </div>
    <a v-if="advertising" :href="'/ad/' + advertising.campaign_random.code + '?view=' + advertising.campaign_random.last_ad_view.id" target="_blank" :style="'background-image:url(' + advertising.campaign_random.image + ');'" class="render_bg_auth hidden sm:flex bg-cover bg-no-repeat bg-center align-items-end flex-none rounded-tr-4 rounded-br-4 p-4 md:px-10 md:py-5">

    </a>
    <div v-else class="render_bg_auth hidden sm:flex bg-cover bg-no-repeat bg-center align-items-end flex-none rounded-tr-4 rounded-br-4 p-4 md:px-10 md:py-5"
    style="background-image:url('/assets/images/layout/Inicio-Sesion.jpg');">
        <!-- RENDER BG -->
    </div>
</div>
</template>
